import { Injectable, inject } from '@angular/core';

import { DetailedGroupingFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Group } from '@frontend/sports/grid/core/feature/model';
import { uniqBy } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class CompactEventService {
    private groupingFactory = inject(DetailedGroupingFactory);

    prepareEventOptionGroups(eventOptionGroups: EventOptionGroup[], groups?: Group[]): EventOptionGroup[] {
        let optionGroups = this.distinctOptionGroups(eventOptionGroups);
        if (optionGroups.every((optionGroup) => optionGroup.detailedGrouping)) {
            optionGroups = this.groupingFactory.groupMarkets(optionGroups);
        }

        if (groups) {
            const activeGroups = groups.filter((group) => group.active);

            return optionGroups.filter((optionGroup) => activeGroups.find((activeGroup) => optionGroup.hasGroup(activeGroup.id)));
        } else {
            return optionGroups;
        }
    }

    private distinctOptionGroups(optionGroups: EventOptionGroup[]): EventOptionGroup[] {
        return uniqBy(optionGroups, (optionGroup) => optionGroup.id);
    }
}
